// iOS scrolls the whole web view to reveal a focused field and does not scroll back when the
// keyboard closes, leaving the header under the notch and a gap at the bottom.
export function shouldResetScroll(s: { scrollX?: number; scrollY: number; activeTag: string }): boolean {
  const typing = s.activeTag === 'INPUT' || s.activeTag === 'TEXTAREA' || s.activeTag === 'SELECT'
  return ((s.scrollX ?? 0) > 0 || s.scrollY > 0) && !typing
}

export function registerKeyboardScrollReset(): void {
  const reset = () => {
    const activeTag = document.activeElement?.tagName ?? 'BODY'
    if (shouldResetScroll({ scrollX: window.scrollX, scrollY: window.scrollY, activeTag })) window.scrollTo(0, 0)
  }
  // The keyboard animation outlasts focusout, so check again after it settles.
  const later = () => { setTimeout(reset, 50); setTimeout(reset, 400) }
  window.addEventListener('focusout', later)
  window.visualViewport?.addEventListener('resize', later)
}
